import {useState,React} from 'react';
import './homepage.css';
import '../App.css';
import VideoModal from './VideoModal';
import BottomBar from './BottomBar';
import { Typewriter } from 'react-simple-typewriter';
import CircularMenu from './CircularMenu';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import Projects from './Projects';
import Footer from './Footer'
import { Link } from 'react-router-dom';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SkillsList from './SkillsList';


const handleDownload = () => {
  const link = document.createElement('a');
  link.href = './resume.docx';
  link.download = 'resume.docx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const Skills = () => {
    // const navigate = useNavigate();

    // function redirectToProjectsPage() {
    //     navigate('/projects', { replace: true });
    // }
    const [showModal, setShowModal] = useState(false);

const handleOpenModal = () => {
  setShowModal(true);
}

const handleCloseModal = () => {
  setShowModal(false);
}
    return (
        <div class="homepagedark">
      <div class="bg1">
        <div class="bg-item"></div>
        <div class="line-group">
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
        </div>
      </div>
      <div class="ololade-group">
        <div class="ololade2">
          <span>SKILLS</span>
          <span class="span2">.</span>
          
        </div>
        </div>
        <div class="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 680,
  }}>
    <button class="download-btndark" onClick={handleOpenModal}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Visume</div>
          <VideoModal 
        show={showModal} 
        handleClose={handleCloseModal} 
        videoSrc="" 
      />
          {/* <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          /> */}
        </button>
  </div>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 830,
  }}>
    <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button>
  </div>

</div>

      </div>

      <div class="i-like-to3" style={{
    overflowY: 'auto'
  }}>
      <SkillsList />
      </div> 
      
      {/* <div class="i-like-to2">
      <Typewriter
        words= {['I am an aspiring Data Science Engineer with expertise in MERN stack, Go, C, and Java. Skilled in using Power BI and Tableau for data visualization. I have experience in full-stack development and creating RESTful APIs. Passionate about data analysis, predictive modeling, and transforming complex data into actionable insights. Committed to continuous learning and innovation in data science.']}

        loop={0}
        cursor
        cursorStyle='_'
        typeSpeed={70}
        deleteSpeed={0}
        delaySpeed={1000}
      />
      </div> */}
      {/* <div class="button1">
        <div class="button-item"></div>
        <div class="say-hello-container">
          <div class="say-hello1">Say Hello</div>
        </div>
      </div> */}
        <BottomBar />
      {/* <div style={{position:'relative'}}>
        <CircularMenu />
        </div> */}
        <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    top: 749,
    bottom: 0,
    right: 50,
  }}>
    <CircularMenu />
  </div>
</div>

    </div>
    );
};
export default Skills;